import script from "./CartTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartTable.vue?vue&type=script&setup=true&lang=ts"

import "./CartTable.vue?vue&type=style&index=0&id=3a2d390f&lang=scss"

const __exports__ = script;

export default __exports__